export interface PCAddress {
  addressType?: string;
  city: string;
  company: string;
  countryCode: string;
  name?: string;
  postalCode: string;
  state: string;
  street1: string;
  street2: string;
}

export type PCOriginType = 'fc' | 'store' | 'at_large';

export const OriginTypeDisplayMap: Record<PCOriginType, string> = {
  at_large: 'At Large',
  fc: 'Fulfillment Center',
  store: 'Store',
};

export interface PCContact {
  email: string;
  name: string;
  phoneNumber: string;
}
export interface PCOrigin {
  activeSchedule?: PCOriginScheduleEntry;
  orchestratedAssetMetadata: OrchestratedAssetMetadata;
  address: PCAddress;
  contact: PCContact;
  description?: string;
  href: string;
  name: string;
  originId: string;
  originType: PCOriginType;
  partnerId: string;
  partnerProvidedId: string;
  scheduleConfigured: boolean;
  tenantLink?: {
    tenantId?: string;
    href?: string;
  };
}
export interface PCOriginResponse {
  results: PCOrigin[];
  orchestratedAssetMetadata: OrchestratedAssetMetadata;
}
export interface PCOriginCreate {
  address: PCAddress;
  contact: PCContact;
  description: string;
  name: string;
  originType: PCOriginType;
  partnerProvidedId: string;
}

export const PC_GLOBAL_TENANT_ID = 'GLOBAL';

export interface ProcessingCutoff {
  expectedDaysToShip: number;
  expectedDaysAndTimeToShip: number;
  shippingCutoffHour: number;
  weekendCutoffHour: number;
  otsTagsEnabled?: boolean;
}

export interface ScheduleHoliday {
  date: string;
  metadata: Record<string, string | undefined>;
}

export interface OrchestratedAssetMetadata {
  orchestrationId: string;
  orchestrationTimeStamp: string;
}

export interface PCOriginScheduleEntry {
  scheduleEntryId: string;
  from: string;
  to: string;
  href: string;
  shippingDays: string[];
  processingCutoff: ProcessingCutoff;
  holidays: ScheduleHoliday[];
  orchestratedAssetMetadata: OrchestratedAssetMetadata;
}
export interface PCOriginScheduleEntryCreate {
  from: string;
  to: string;
  shippingDays: string[];
  processingCutoff: ProcessingCutoff;
  holidays: ScheduleHoliday[];
}

export interface PCOriginSchedule {
  orchestratedAssetMetadata: OrchestratedAssetMetadata;
  results: PCOriginScheduleEntry[];
}

export interface PCTenantResponse {
  orchestratedAssetMetadata: OrchestratedAssetMetadata;
  results: PCTenant[];
}

export interface PCTenant {
  origins: PCOrigin[];
  name: string;
  href: string;
  description: string;
  partnerProvidedId: string;
  taxIdentificationNumber: string;
  tenantId: string;
  unitedStatesPrincipalPartyInInterestContact: PCContact;
  unitedStatesPrincipalPartyInInterestAddress: PCAddress;
}
